export const INDUSTRIES = [
  'Automobil',
  'Bau & Immobilien',
  'Bildung & Forschung',
  'Chemie & Materialien',
  'Consulting & Beratung',
  'E-Commerce & Handel',
  'Energie & Versorgung',
  'Finanzdienstleistungen',
  'Gesundheitswesen',
  'Landwirtschaft',
  'Logistik & Transport',
  'Luft- & Raumfahrt',
  'Marketing & Medien',
  'Non-Profit & NGO',
  'Pharma & Biotech',
  'Produktion & Industrie',
  'Technologie & IT',
  'Telekommunikation',
  'Tourismus & Gastronomie',
  'Versicherungen',
  'Verteidigung & Sicherheit'
];
